import React from 'react';
import PropTypes from 'prop-types';

import Table from '../../components/Table';
import { contactShape, getContactDetails } from './util';
import ContactNotes from './contact-notes';

import './styles.css';

class Contact extends React.PureComponent {
  static propTypes = {
    contact: contactShape.isRequired,
    handleSelect: PropTypes.func,
    changeRepVisitsContactNotes: PropTypes.func.isRequired,
  };

  render() {
    const { contact, handleSelect, changeRepVisitsContactNotes } = this.props;
    const contactDetails = getContactDetails(contact);
    return (
      <Table.Row styleName="contact-row" onClick={() => handleSelect(contact)}>
        <Table.Cell width={3}>
          <div styleName="person">
            <div styleName="avatar" aria-hidden="true" data-cy="avatar-circle">
              {contactDetails.avatar ?
                <img src={contactDetails.avatar} alt={contactDetails.fullName} /> :
                <div styleName="initials">{contactDetails.initials}</div>}
            </div>
            <div styleName="info">
              <h2 styleName="name">{contactDetails.fullName}</h2>
              <div styleName="title" className="hidden-mobile">{contactDetails.position}</div>
              <div styleName="school-name" className="hidden-tablet hidden-computer visible-mobile-block">
                {contactDetails.schoolName}
              </div>
            </div>
          </div>
        </Table.Cell>
        <Table.Cell className="hidden-mobile" width={5}>
          <div styleName="school-name">
            {contactDetails.schoolName}
          </div>
          <div styleName="address">
            {contactDetails.address}
          </div>
        </Table.Cell>
        <Table.Cell className="hidden-mobile" width={2}>
          <span>{contactDetails.phone}</span>
        </Table.Cell>
        <Table.Cell className="hidden-mobile" width={3}>
          <div>
            {contactDetails.mail}
          </div>
        </Table.Cell>
        <Table.Cell className="hidden-mobile" width={3}>
          <ContactNotes
            notes={contactDetails.notes}
            changeRepVisitsContactNotes={changeRepVisitsContactNotes}
            contact={contact}
          />
        </Table.Cell>
      </Table.Row>
    );
  }
}

export default Contact;
